// Adapted from https://git.hubteam.com/HubSpot/customer-data-properties/blob/master/static/js/input/PropertyInputHidden.tsx
// Slack context https://hubspot.slack.com/archives/CT1NEGM5F/p1677532712054919?thread_ts=1677532155.990919&cid=CT1NEGM5F

import { FLINT } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { memo } from 'react';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const getDataAttributes = props => {
  return Object.keys(props).reduce((acc, key) => {
    if (key.startsWith('data')) {
      acc[key] = props[key];
    }
    return acc;
  }, {});
};

// NOTE: We need an actual property defintion type in redux

const renderTooltipTitle = property => {
  if (property && property.label) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkDealTable.propertyInputHidden.noPermissionWithLabel",
      options: {
        propertyLabel: property.label
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "frameworkDealTable.propertyInputHidden.noPermission"
  });
};
const PropertyInputHidden = props => /*#__PURE__*/_jsx("span", Object.assign({
  "data-test-id": "property-input-hidden"
}, getDataAttributes(props), {
  children: /*#__PURE__*/_jsx(UITooltip, {
    title: renderTooltipTitle(props.property),
    autoPlacement: true,
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "hide",
      size: "xxs",
      color: FLINT
    })
  })
}));
export default /*#__PURE__*/memo(PropertyInputHidden);